export const en = {
  auth: {
    logout: "Logout",
    language: "Language",
    login: "Go to login screen",
    logoutTitle: "Your session is expired.",
    logoutDescription: "You will be moved to login screen automatically in 5 seconds or you can click the button to move immediately.",
    en: "English",
    he: "Hebrew",
    account: "Account Settings",
  },
  layout: {
    chooseSystem: "Choose system",
    sure: "Are you sure?",
    search: "Search",
    system: "System",
    stock: "Stock",
    activate: "Activate",
    confirm: "Confirm",
    cancel: "Cancel",
    submit: "Submit",
    home: "Home",
    control: "Control",
    orders: "Orders",
    metadata: "Metadata Entries",
    monitoring: "Monitoring",
    replenishment: "Replenishment",
    transfers: "Transfers Data",
    keys: "Keys",
    indexing: "Indexing requests",
    streams: "Live Streams",
    library: "Library",
    store: "Store",
    support: "Support",
    warranty: "Warranty",
    "products-portfolio": "Products Portfolio",
    orderDetail: "Order Detail",
    tableRows: "Rows per page",
    portfolio: "Products Portfolio",
    uploadTitle: "Upload image",
    uploadRule: "Max file size: {{size}}MB",
    uploadTip: "Browse",
    pleaseWait: "Please wait",
    fileSizeError: "Image size exceeds {{size}} MB. Please select a smaller image.",
    users: "Users",
    profile: "Account",
    back: "Back",
    logout: "Logout"
  },
  navigation: {
    home: "Home",
    orders: "Orders",
    metadata: "Metadata",
    stock: "Stock",
    store: "Store",
    productsPortfolio: "Products Portfolio",
    users: "Users Management",
    account: "Account",
    profile: "My profile"
  },
  systems: {
    hours: "hours",
    days: "days",
    title: "System",
    lastUpdated: "Last updated: {{time}} ago",
    open: "Open",
    closed: "Closed",
    confirmation: "Are you sure?",
    active: "Active",
    inactive: "Deactivated",
    ago: "ago",
    summary: "Summary",
    pallets: "Pallets",
    emptyPallets: "Empty pallets",
    temperature: "Temperature",
    packerStock: "Packer Stock",
    monitor: "Monitor",
    keys: "Keys",
    yes: "Yes",
    unavailable: "Currently unavailable",
    buffers: "Buffers",
    mode: "System Mode",
    pickup: "Pickup",
    activity: "Activity",
    containerState: "Container state",
    activeTasksTitle: "Enabled system tasks",
    activeTasksDescription: "Tasks the system performs",
    maintenance: "Maintenance",
    collection: "Packs collection",
    newOrdersTitle: "Receive new orders",
    newOrdersDescription: "System receives new orders from remote clients",
    availability: "Availability",
    orders: "Orders",
    reservations: "Reservations",
    validations: "Validations",
    machineSpeed: "Machine speed",
    Low: "Low",
    Medium: "Medium",
    Fast: "Fast",
    compressor: "Compressor",
    on: "On",
    off: "Off",
    notAvailable: "Not available",
    stateError: "System state is currently unavailable"
  },
  stock: {
    title: "Stock",
    pallet: "Pallet",
    loadedAt: "Loaded at",
    markForMaintenance: "Mark for maintenance",
    totalProducts: "Total products",
    name: "Name",
    sku: "SKU",
    quantity: "Quantity",
    shop: "Shop",
    cart: "Cart",
    clear: "Clear All",
    empty: "Cart Is Empty",
    total: "Total",
    order: "Order Now",
    orderFail: "Order creation failed",
    orderSuccessTitle: "Yayyy!",
    orderSuccessDescription: "Order number {{id}} created successfully",
    searchPlaceholder: "Search products by name",
  },
  orders: {
    id: "ID",
    time: "Date & Time",
    source: "Source",
    packs: "# of packs",
    status: "Order Status",
    displayCode: "Display Code",
    priority: "Priority",
    delivery: "Delivery",
    total: "Total orders",
    selectStatuses: "Select statuses",
    idPlaceholder: "Search by ID",
    searchPlaceholder: "Search by details",
    searchHint: "Type at least 2 symbols",
    statusPlaceholder: "Select statuses",
    resetFilters: "Reset Filters",
    table: "Table",
    board: "Board",
    noOrders: "No orders to show",
    export: "Export to CSV",
    parts: "Parts",
    api: "API",
    user: "User",
    processMany: "Process Selected Orders",
    selectedOrder: "1 Order Selected",
    selectedOrders: "{{amount}} Orders Selected",
    processSuccess: "Orders processed successfully",
    processPartiallySuccess: "Some orders not processed, please try again",
    processError: "Failed to process orders",
    search: "Search",
    clear: "Clear"
  },
  order: {
    details: "User Details",
    id: "Order ID",
    packs: "Packs",
    code: "Display Code",
    pinCode: "Pin Code",
    phone: "Phone number",
    timeline: "Timeline",
    name: "Name",
    address: "Address",
    locale: "Locale",
    datetime: "Date & Time",
    priority: "Priority",
    productName: "Product name",
    sku: "SKU",
    quantity: "QTY",
    collectedQuantity: "Collected",
    returnedQuantity: "Returned",
    refundedQuantity: "Refunded",
    totalProducts: "Total Products",
    payment: "Payment",
    pending: "Pending",
    queued: "Queued",
    fetched: "Fetched",
    collecting: "Collecting",
    collected: "Collected",
    ready: "Ready",
    delivering: "Delivering",
    delivered: "Delivered",
    error: "Error",
    cancelled: "Cancelled",
    "payment-queued-label": "Skip Payment",
    "pending-queued-label": "Queue",
    "ready-delivering-label": "Deliver",
    "error-pending-label": "Retry Scheduled",
    "error-queued-label": "Retry Now",
    "cancelled-label": "Cancel",
    "process-refunds": "Process Refunds Now",
    identifier: "Identifiers",
    manuallyChangeReturnedQuantity: "Manually change returned quantity",
    changeReturnedQuantity: "Change Returned Quantity",
    returnedQuantityWarning: "Returned quantity can't exceed collected quantity",
    update: "Update",
    successQuantityMessage: "Returned quantity was updated successfully",
    errorQuantityMessage: "There is an error while updating returned quantity",
    processRefundsSuccess: "Refunds were processed successfully",
    processRefundsError: "There is an error while processing refunds",
  },
  system: {
    searchPlaceholder: "Search in products",
    id: "ID",
    name: "Name",
    identifier: "Identifiers",
    totalQuantity: "Total",
    assignedQuantity: "Assigned",
    reservedQuantity: "Reserved",
    availableQuantity: "Available",
    total: "Total products",
    healthy: "Healthy",
    online: "Online",
    paused: "Paused",
    estop: "E-Stop",  
  },
  productsPortfolio: {
    products: "Products",
    name: "Name",
    brand: "Brand",
    type: "Type",
    pickingType: "Picking type",
    nutrition: "Nutrition",
    price: "Price",
    defaultPrice: "Default Price",
    priceSublines: "Price Sublines",
    imageSize: "Image size",
    category: "Category",
    label: "Label",
    categoryName: "Category name",
    labelName: "Label name",
    sku: "SKU",
    disabledSystems: "Disabled Systems",
    searchPlaceholder: "Search in products",
    categoriesPlaceholder: "All Categories",
    labelsPlaceholder: "All Labels",
    disabledSystemsFilter: "Only products with disabled systems",
    resetFilters: "Reset filters",
    productStatus: "Product status",
    productName: "Product name",
    productDescription: "Product description",
    displaySize: "Display size",
    productType: "Product type",
    productPickingType: "Picking type",
    productImage: "Product image",
    temperature: "Temperature",
    regular: "Regular",
    bundle: "Bundle",
    automated: "Automated",
    manual: "Manual",
    external: "External",
    integrated: "Integrated",
    frozen: "Frozen",
    fresh: "Fresh",
    chilled: "Chilled",
    cold: "Cold",
    ambient: "Ambient",
    none: "None",
    properties: "Properties",
    weight: "Weight",
    size: "Size",
    small: "Small",
    medium: "Medium",
    big: "Big",
    create: "Create",
    namePlaceholder: "Enter product name",
    descriptionPlaceholder: "Enter product description",
    brandPlaceholder: "Enter brand name",
    nutritionPlaceholder: "Enter nutrition information",
    pricePlaceholder: "Enter price",
    heightMm: "Height (mm)",
    heightMmPlaceholder: "Enter height in millimeters",
    widthMm: "Width (mm)",
    widthMmPlaceholder: "Enter width in millimeters",
    lengthMm: "Length (mm)",
    lengthMmPlaceholder: "Enter length in millimeters",
    weightKg: "Weight (kg)",
    weightKgPlaceholder: "Enter weight in kilograms",
    volumeL: "Volume (L)",
    volumeLPlaceholder: "Enter volume in liters",
    imageSizePlaceholder: "Enter image size",
    categoryNamePlaceholder: "Enter category name",
    labelNamePlaceholder: "Enter label name",
    dropdownPlaceholder: "Please select",
    createTitle: "Create New Product",
    createProductButton: "New Product",
    requiredMessage: "This field is required",
    createProductSuccess: "Product created successfully",
    createProductFail: "Error while creating product",
    updateProductSuccess: "Product updated successfully",
    updateProductFail: "Error while updating product",
    approveProductSuccess: "Product approved successfully",
    approveProductFail: "Error while approving product",
    revertProductSuccess: "Product reverted successfully",
    revertProductFail: "Error while reverting product",
    approveProductsSuccess: "Products approved successfully",
    approveProductsFail: "Error while approving products",
    declineProductSuccess: "Product declined successfully",
    declineProductFail: "Error while declining product",
    archiveProductSuccess: "Product archived successfully",
    archiveProductFail: "Error while archiving product",
    unarchiveProductSuccess: "Product unarchived successfully",
    unarchiveProductFail: "Error while unarchiving product",
    optional: "(Optional)",
    nameSuccess: "Product name updated successfully",
    nameError: "Error while updating product name",
    categorySuccess: "Product category updated successfully",
    categoryError: "Error while updating product category",
    createCategoryError: "Error while creating product category",
    noCategory: "No category",
    skusTitle: "Product SKUs",
    addSku: "Add SKU",
    createCategory: "Create new Category",
    createLabel: "Create new Label",
    skuNamePlaceholder: "Enter SKU name",
    barCodes: "Barcodes",
    barCodesPlaceholder: "Enter barcodes",
    barCodesAddPlaceholder: "Enter barcode to add",
    barCodesTip: "Separate multiple barcodes by a comma",
    cancel: "Cancel",
    save: "Save",
    addSkuSuccess: "SKU successfully added to the product",
    addSkuError: "Error while adding sku to the product",
    addBarcodeSuccess: "Barcode successfully added to the sku",
    addBarcodeError: "Error while adding barcode to the sku",
    emptyBarcodeError: "Barcode should not be empty",
    more: "more",
    status: "Status",
    pending: "Pending",
    approved: "Approved",
    active: "Active",
    disabled: "Disabled",
    inactive: "Inactive",
    approvePendingProducts: "Approve Pending Products",
    details: "Details",
    productSkus: "Product SKUs",
    externalLabel: "External storage",
    enabled: "Enabled",
    saveChanges: "Save changes",
    declineProduct: "Decline Product",
    approveProduct: "Approve Product",
    archiveProduct: "Archive Product",
    unarchiveProduct: "Unarchive Product",
    revertProduct: "Revert Product",
    statusesPlaceholder: "All Statuses",
    confirmation: "Are you sure?",
    export: "Export to CSV",
    archive: "Archive",
    unarchive: "Unarchive",
    identifiers: "Identifiers",
    prices: "Prices",
    value: "Value",
    addIdentifier: "Add Identifier",
    updatePrice: "Update price",
    selectIdentifierType: "Select Identifier Type",
    enterIdentifierValue: "Enter Identifier Value",
    addNewIdentifier: "Add New Identifier",
    defaultPrice: "Default price",
    enterPriceValue: "Enter Price Value",
    addNewSubline: "Add Price Subline",
    priceAmount: "Amount",
    priceDescription: "Description",
    modifiers: "Modifiers",
    key: "Key",
    values: "Values",
    valueName: "Value Name",
    addModifier: "Add Modifier",
    enterModifierKey: "Enter Modifier Key",
    enterModifierName: "Enter Modifier Name",
    enterModifierValue: "Enter Modifier Value",
    enterModifierValueName: "Enter Modifier Value Name",
    addNewModifier: "Add New Modifier",
    modifierValues: "Modifier Values",
    addValue: "Add Value",
    priceChangeSuccess: "Prices were updated successfully",
    priceChangeError: "Error happened while updating prices",
    deleteProduct: "Delete Product",
    deleteProductConfirmation: "Are you sure you want to delete this product?",
    deleteProductSuccess: "Product deleted successfully",
    deleteProductFail: "Error while deleting product",
  },
  store: {
    identifier: "Identifiers",
    searchPlaceholder: "Search in products",
    cart: "Cart",
    resetFilters: "Reset Filters",
    name: "Name",
    totalQuantity: "total",
    availableQuantity: "available",
    assignedQuantity: "assigned",
    reservedQuantity: "reserved",
    id: "ID",
    sku: "SKU",
    quantity: "QTY",
    add: "Add to cart",
    total: "Total products",
    clear: "Clear all",
    create: "Create an order",
    placeOrderSuccess: "Order created successfully",
    placeOrderError: "Error while creating order",
  },
  support: {
    support: "Support",
    pageTip: "Please provide the information regarding your case below, and our support team will assist you as soon as possible.",
    subject: "Subject",
    subjectPlaceholder: "Enter subject of your case",
    description: "Description",
    descriptionPlaceholder: "Describe details",
    submit: "Submit",
    successTitle: "Case submitted successfully!",
    successDescription: "The Support team will assist you as soon as possible. For further assistance you can find the ticket details in your email.",
    close: "Close",
    modalDescription: "Please provide the information regarding your case below.",
    cancel: "Cancel",
  },
  metadata: {
    filterName: "Search by Name",
    filterRequired: "Show only required",
    filterClear: "Clear filter",
    entries: "Entries",
    name: "Name",
    options: "Options",
    type: "Type",
    required: "Required",
    edit: "Edit",
    delete: "Delete",
    Int: "Integer",
    Bool: "Bool",
    String: "String",
    Float: "Float",
    addNew: "Add New Entry",
    namePlaceholder: "Enter Name",
    typePlaceholder: "Enter Type",
    optionsPlaceholder: "Add Options, comma separated",
    requiredLabel: "Mark as required",
    cancel: "Cancel",
    add: "Add Entry",
    editDrawerTitle: "Edit Metadata",
    save: "Save changes",
    createSuccessMessage: "Metadata entry successfully created!",
    createErrorMessage: "Error while creating metadata entry!",
    updateSuccessMessage: "Metadata entry successfully updated!",
    updateErrorMessage: "Error while updating metadata entry!",
    deleteSuccessMessage: "Metadata entry successfully deleted!",
    deleteErrorMessage: "Error while deleting metadata entry!",
    confirmationTitle: "Confirm deletion",
    deletionConfirmation: "Are you sure you want to delete metadata entry?",
    confirm: "Confirm",
    requiredMessage: "This field is required",
  },
  users: {
    selectTypes: "Select types",
    searchPlaceholder: "Search by Name or Email",
    searchHint: "Type at least 2 symbols",
    typePlaceholder: "Select types",
    resetFilters: "Reset Filters",
    users: "Users",
    permissions: "Permissions",
    name: "Name",
    email: "Email",
    userType: "User Type",
    add: "Add",
    User: "User",
    Admin: "Admin",
    SuperAdmin: "SuperAdmin",
    total: "Total",
    edit: "Edit",
    block: "Block",
    unblock: "Unblock",
    delete: "Delete",
    requiredMessage: "This field is required",
    emailValidationMessage: "Email is not valid",
    namePlaceholder: "Enter name",
    emailPlaceholder: "Enter email",
    type: "Assign type",
    pleaseSelect: "Please select",
    createSuccessMessage: "User successfully created!",
    createErrorMessage: "Error while creating user!",
    updateSuccessMessage: "User successfully updated!",
    updateErrorMessage: "Error while updating user!",
    addNew: "Add new user",
    deleteUserConfirmation: "Delete User",
    deleteUserConfirmationDescription: "Are you sure you want to remove the user from the system?",
    deleteUserSuccess: "User successfully deleted!",
    deleteUserError: "Error while deleting user!",
    addUser: "Add user",
    addRole: "Add role",
    assignUser: "Add user to specific permission",
    assignRole: "Add roles for the {{name}}",
    assignUserPlaceholder: "Search by name",
    assignRolePlaceholder: "Search role",
    cancel: "Cancel",
    assignSuccess: "Users successfully assigned to the role!",
    assignError: "Error while assigning users to the role!",
    assignRoleSuccess: "Roles successfully assigned to the user!",
    assignRoleError: "Error while assigning roles to the user!",
    revoke: "Revoke",
    revokeSuccess: "User successfully revoked from the role!",
    revokeError: "Error while revoking user from the role!",
  },
  settings: {
    compare: "Stock compare feature",
    shipping: "Shipping feature",
  },
  userRoles: {
    orderData: {
      title: "Order Data Access",
      description: "View all data related to orders.",
    },
    orderCreation: {
      title: "Order Creation",
      description: "Submit new orders via the Store page.",
    },
    orderManagement: {
      title: "Order Management",
      description: "Manage the full order lifecycle, including queueing, canceling, and manually collecting orders.",
    },
    replenishmentData: {
      title: "Replenishment Data Access",
      description: "View complete details of replenishment sessions and operations, including machine replenishment keys.",
    },
    indexingTaskControl: {
      title: "Indexing Task Control",
      description: "Create and manage system indexing tasks, with the option to cancel tasks.",
    },
    basicReplenishmentKeyCreation: {
      title: "Basic Replenishment Key Creation",
      description: "Create keys for inserting and extracting pallets.",
    },
    advancedReplenishmentKeyCreation: {
      title: "Advanced Replenishment Key Creation",
      description: "Create keys with additional privileges, including Safe and Jog modes.",
    },
    keyManagement: {
      title: "Key Management",
      description: "Deactivate or reactivate existing keys.",
    },
    productPortfolioAccess: {
      title: "Product Portfolio Access",
      description: "View product data along with metadata configuration.",
    },
    clientConfigurationManagement: {
      title: "Client Configuration Management",
      description: "Modify client configurations to control cloud services and machine operations.",
    },
    systemDataAccess: {
      title: "System Data Access",
      description: "View detailed system information, including status, structure, and stock levels.",
    },
    systemStateManagement: {
      title: "System State Management",
      description: "Control systems state settings, such as accepting new orders, pausing/unpausing, and activating/deactivating system tasks like Fulfillment and Replenishment.",
    },
    mediaDataAccess: {
      title: "Media Data Access",
      description: "View live camera feeds and stored video content.",
    },
    mediaAccess: {
      title: "Media Access",
      description: "View live camera feeds and stored video content.",
    },
    mediaCreation: {
      title: "Media Creation",
      description: "Submit new video requests.",
    },
    systemControlManagement: {
      title: "System Control Management",
      description: "Take control of the system and execute operations remotely.",
    },
    rStopControl: {
      title: "R-Stop Control",
      description: "Activate or deactivate the R-Stop remotely.",
    },
    productMetadataManagement: {
      title: "Product Metadata Management",
      description: "Add, update, or delete product metadata. Manage metadata types and requirements.",
    },
    productPortfolioManagement: {
      title: "Product Portfolio Management",
      description: "Create new products, categories, and SKUs. Update unapproved products with details such as name, image, category, and metadata.",
    },
    productPortfolioAdministration: {
      title: "Product Portfolio Administration",
      description: "Manage product permissions, including approving products and updating previously approved ones.",
    },  
  },
  home: {
    selectSystem: "Select a system"
  },
  profile: {
    profile: "Profile",
    name: "Name",
    email: "Email",
    permissions: "My Permissions",
  }
};
